<script setup>
import { refThrottled, syncRef } from '@vueuse/core'
import { shallowRef, watch } from 'vue'
import { trim } from 'lodash-es'

const model = defineModel()
const props = defineProps({
  target: {
    type: String,
    requred: true,
  },
  label: {
    type: String,
    default: 'Ссылка на запись',
  },
  controlId: String,
  linkLabel: String,
  class: String,
  modelValue: null,
  layout: null,
  id: null,
})

const number = refThrottled(model, 200)
const link = shallowRef(null)

const generators = {
  coa(id) {
    return (
      'https://atd.systems/cloud/coa?ID=' + id
    )
  },
}

syncRef(model, number, { direction: 'ltr', flush: 'pre' })

watch(
  () => [number.value, props.target],
  ([number, target]) => {
    const val = !trim(number) ? null : (link.value = generators[target](number))

    link.value = val
    model.value = number
  },
  { flush: 'pre', immediate: true }
)
</script>
<template>
  <div class="schema-field-layout">
    <label class="form-label" :for="controlId">{{ label }}</label>
    <input type="text" class="form-control" v-model="model" />
  </div>
  <div class="schema-field-layout" v-if="link">
    <div class="form-label">{{ linkLabel }}</div>
    <a :href="link" target="_blank">{{ link }}</a>
  </div>
</template>
<style scoped>
a {
  word-break: break-all;
}
</style>
